export function MiroIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M12.5 24.5C19.1274 24.5 24.5 19.1274 24.5 12.5C24.5 5.87258 19.1274 0.5 12.5 0.5C5.87258 0.5 0.5 5.87258 0.5 12.5C0.5 19.1274 5.87258 24.5 12.5 24.5Z"
        fill="#FFD02F"
      />
      <path
        d="M16.1267 4.90002H13.9315L15.7599 8.11304L11.7362 4.90002H9.54092L11.5528 8.82902L7.34566 4.90002H5.15039L7.34566 9.90002L5.15039 19.9H7.34566L11.5528 9.18405L9.54092 19.9H11.7362L15.7599 8.47399L13.9315 19.9H16.1267L20.1504 7.39707L16.1267 4.90002Z"
        fill="#050038"
      />
    </svg>
  );
}
